export enum EntryStatus {
  PreEntried = "pre_entried", // レジュメ提出待ち
  Entried = "entried", // 申込済
  Elected = "elected", // 参加予定
  Canceled = "canceled", // キャンセル
  Defeated = "defeated" // 落選
}
